import React from "react";
import Filter from "./Filter";

export default props => (
  <Filter
    width={100}
    name="guests"
    title="Guests"
    type="number"
    label={value => `${value} Guests`}
    normalize={value => (value ? Number(value) : null)}
    placeholder={"#"}
    {...props}
  />
);
